/**
 * Creates a function that will resolve its arguments against the given CSS module object.
 *
 * The returned function has the following properties:
 *
 * 1. Ignores falsey arguments (e.g., null, undefined, empty string)
 * 2. Issues a console warning for each argument that is not a key in the CSS module object.
 * 3. Returns an object with the shape `{ className: string }`.
 *
 * Typical usage looks like:
 *
 * ```
 * import cssModule from "./myStyles.css";
 * const className = makeClassNameFunctionForModules(cssModule);
 * return (<MyComponent {...className("someClass")} />);
 * ```
 *
 * @param cssModule the imported CSS module object.
 * @returns {function(...[*])} the className function described above.
 */
export function makeClassNameFunctionForModule(cssModule) {
    return (...classNames) => {
        const classes = [];
        for (const className of classNames) {
            if (className) {
                const moduleClassName = cssModule[className];
                if (!moduleClassName) {
                    console.warn(
                        "className ",
                        className,
                        " was not found in CSS module ",
                        cssModule
                    );
                } else {
                    classes.push(moduleClassName);
                }
            }
        }
        return {
            className: classes.join(" ")
        };
    };
}



// WEBPACK FOOTER //
// ./src/utils/cssModules.js